export default {
  computed: {
    isAuth() {
      return !!this.$inertia?.page?.props?.auth?.user?.id
    },
    isAdmin() {
      return this.isAuth && this.$inertia.page.props.auth.user.isAdmin
    },
    isMaster() {
      return this.isAuth && this.$inertia.page.props.auth.user.isMaster
    },
    isSupervisor() {
      return this.isAuth && this.$inertia.page.props.auth.user.isSupervisor
    },
    authUser() {
      return this.$inertia?.page?.props?.auth?.user
    },
    hasSheet() {
      return !!this.$inertia?.page?.props?.auth?.user?.sheet?.id
    },
    sheetIsActive() {
      return this.$inertia?.page?.props?.auth?.user?.sheet?.id && this.$inertia?.page?.props?.auth?.user?.sheet?.is_active
    },
  },
}
